import React from "react";

import {Icomponent} from "../../../core/components/basegame/interface/Icomponent";
import {multiplierAssetConfig} from "../../../data/multiplier";


interface IframeworkTruncateHitArea {
    data: {
        COMPONENTS: any
    }

}

export const frameworkTruncateHitArea: IframeworkTruncateHitArea = {

    data: {
        "COMPONENTS": [

            {
                "name": "hitArea_Graphic",
                "type": "Graphic",
                "shape": "rectangle",
                "visible": true,
                "alpha": 0.01,
                "color": "0x746AB0",
                "layout": false,
                "uimode": "desktop",
                "x": 333,
                "y": 242,
                "width": 1250,
                "height": 630,

            },
            {
                "name": "horizontalHitArea_Graphic",
                "type": "Graphic",
                "shape": "rectangle",
                "visible": true,
                "alpha": 0.01,
                "color": "0x746AB0",
                "layout": false,
                "uimode": "desktop",
                "x": 544,
                "y": 85,
                "width": 830,
                "height": 173,

            },
            {
                "name": "hitArea_Graphic_mobile",
                "type": "Graphic",
                "shape": "rectangle",
                "visible": true,
                "alpha": 0.01,
                "color": "0x746AB0",
                "layout": true,
                "uimode": "mobile",
                "x": 333,
                "y": 242,
                "width": 1250,
                "height": 630,

            },
            {
                "name": "horizontalHitArea_Graphic_mobile",
                "type": "Graphic",
                "shape": "rectangle",
                "visible": true,
                "alpha": 0.01,
                "color": "0x746AB0",
                "layout": true,
                "uimode": "mobile",
                "x": 544,
                "y": 85,
                "width": 830,
                "height": 173,

            },

        ],
    }

};

export const TruncateHitAreaConfigurationContext = React.createContext(
    {}
);